import { render, staticRenderFns } from "./UsersReportUser.vue?vue&type=template&id=21e7e5ae&scoped=true&"
import script from "./UsersReportUser.vue?vue&type=script&lang=js&"
export * from "./UsersReportUser.vue?vue&type=script&lang=js&"
import style0 from "./UsersReportUser.vue?vue&type=style&index=0&id=21e7e5ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e7e5ae",
  null
  
)

export default component.exports